var _path, _path2, _path3, _path4, _path5, _path6, _rect, _circle, _circle2, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8 16.7909 9.79086 15 12 15H44C46.2091 15 48 16.7909 48 19V45C48 47.2091 46.2091 49 44 49H12C9.79086 49 8 47.2091 8 45V19Z",
    fill: "#262222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V12",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 17V12",
    stroke: "#262222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26C50.2091 26 52 27.7909 52 30V34C52 36.2091 50.2091 38 48 38V26Z",
    fill: "#262222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30C4 27.7909 5.79086 26 8 26V38C5.79086 38 4 36.2091 4 34V30Z",
    fill: "#262222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C11 18.8954 11.8954 18 13 18H43C44.1046 18 45 18.8954 45 20V44C45 45.1046 44.1046 46 43 46H13C11.8954 46 11 45.1046 11 44V20Z",
    fill: "#171616"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#342F2F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 4,
    fill: "#262222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 4,
    fill: "#262222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H24C24 29.6569 22.6569 31 21 31C19.3431 31 18 29.6569 18 28Z",
    fill: "#F26D6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28H38C38 29.6569 36.6569 31 35 31C33.3431 31 32 29.6569 32 28Z",
    fill: "#F26D6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot2);
export default __webpack_public_path__ + "static/media/robot_2.de6cad95694b2a159d909ee9edd3badd.svg";
export { ForwardRef as ReactComponent };